import React, { useEffect, useMemo, useRef, useState } from 'react';

/*
 * Editor de texto plano: .txt, .bat, .json, .log, código…
 *
 * Drive no es un gestor de .docx. Un archivo de texto se abre TAL CUAL —
 * monoespaciado, con sus saltos de línea y su tabulador— y se guarda igual.
 * Pasarlo por el editor de documentos le inventaba párrafos y lo devolvía
 * convertido en Word.
 */

/** Número de líneas sin recorrer la cadena entera más de una vez. */
function contarLineas(texto) {
  let n = 1;
  for (let i = 0; i < texto.length; i += 1) if (texto[i] === '\n') n += 1;
  return n;
}

export default function TextEditor({ value, onChange, readOnly = false, wrap = false }) {
  const area = useRef(null);
  const gutter = useRef(null);
  const [lineas, setLineas] = useState(() => contarLineas(value || ''));

  useEffect(() => { setLineas(contarLineas(value || '')); }, [value]);

  const numeros = useMemo(() => {
    const out = [];
    for (let i = 1; i <= lineas; i += 1) out.push(i);
    return out;
  }, [lineas]);

  // El margen de números sigue al texto al desplazarse
  const alDesplazar = () => {
    if (gutter.current && area.current) gutter.current.scrollTop = area.current.scrollTop;
  };

  // El tabulador escribe un tabulador; salir del campo se hace con Escape+Tab
  const alTeclear = (e) => {
    if (e.key !== 'Tab' || e.shiftKey || readOnly) return;
    e.preventDefault();
    const el = e.target;
    const { selectionStart: a, selectionEnd: b } = el;
    const nuevo = `${el.value.slice(0, a)}\t${el.value.slice(b)}`;
    onChange(nuevo);
    requestAnimationFrame(() => {
      el.selectionStart = a + 1;
      el.selectionEnd = a + 1;
    });
  };

  return (
    <div className="texto-editor" data-testid="editor-texto">
      <div className="texto-numeros" ref={gutter} aria-hidden="true">
        {numeros.map((n) => <div key={n}>{n}</div>)}
      </div>
      <textarea
        ref={area}
        className="texto-campo"
        value={value || ''}
        readOnly={readOnly}
        spellCheck={false}
        autoCapitalize="off"
        autoCorrect="off"
        wrap={wrap ? 'soft' : 'off'}
        aria-label="Contenido del archivo"
        onScroll={alDesplazar}
        onKeyDown={alTeclear}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
